import { render, staticRenderFns } from "./EditSimplified.vue?vue&type=template&id=606892c8&scoped=true"
import script from "./EditSimplified.vue?vue&type=script&lang=js"
export * from "./EditSimplified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606892c8",
  null
  
)

export default component.exports